import React, {useEffect} from "react"
import { useStaticQuery, graphql, Link } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Slider from "react-slick"

const HeroSectionFade = () => {

    const data = useStaticQuery(graphql`
        query {
            bannerOne: file(relativePath: { eq: "data-dinner.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerTwo: file(relativePath: { eq: "data-flames.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
            bannerThree: file(relativePath: { eq: "data-pipes.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 2000
                        placeholder: TRACED_SVG
                        formats: [AUTO, WEBP, AVIF]
                    )
                }
            }
        }
    `)

    return(
        <HeroMain>
            <div>
                <Slider {...fadeSettings}>
                    <div>
                        <GatsbyImage className={"hero-bg hero-bg-1"} image={data.bannerOne.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Dinner Data"}/>
                        <div class="hero-content">
                            <h2>Food Marketing & PR</h2>
                            <p>Food and Energy are life's essentials and Hahn's focus.</p>
                        </div>
                    </div>
                    <div>
                        <GatsbyImage className={"hero-bg hero-bg-2"} image={data.bannerTwo.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Flames Data"}/>
                        <div class="hero-content">
                            <h2>Energy Marketing & PR</h2>
                            <p>Food and Energy are life's essentials and Hahn's focus.</p>
                        </div>
                    </div>
                    <div>
                        <GatsbyImage className={"hero-bg hero-bg-3"} image={data.bannerThree.childImageSharp.gatsbyImageData} alt={"Hahn.Agency Limes Data"}/>
                        <div class="hero-content">
                            <h1>Predictive Marketing & PR</h1>
                            <p>Food and Energy are life's essentials and Hahn's focus.</p>
                        </div>
                    </div>
                </Slider>
            </div>
        </HeroMain>
    )

}

const fadeSettings = {
    dots: false,
    arrows: false,
    fade: true,
    infinite: true,
    autoplay: true,
    speed: 2500,
    autoplaySpeed: 1000,
    slideToShow: 1,
    slideToScroll: 1
}

const HeroMain = styled.section`
    background-color: #000;
    .slick-list {
        width: 100%
    }
    .gatsby-image-wrapper {
        width: 100%;
        > div {
            width: 100%;
            max-width: 100%;
        }
        img {
            width: 100%;
            max-width: 100%;
        }
    }
    .hero-content {
        position: absolute;
        transition-delay: 1.5s;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        h1 {
            font-family: "Nobel",sans-serif;
            font-size: 130px;
            line-height: 1.1;
            color: #fff;
            text-align: center;
            transition-duration: .3s;
        }
        h2 {
            font-family: "Nobel",sans-serif;
            font-size: 130px;
            line-height: 1.1;
            color: #fff;
            text-align: center;
            transition-duration: .3s;
        }
        p{
            font-family: "Work Sans";
            font-size: 40px;
            font-weight: 400;
            line-height: 1.2;
            color: #fff;
            text-align: center;
            transition-duration: .3s;
        }
    }
    @media(max-width: 1420px) {
        .hero-content {
            h1 {
                font-size: 100px;
            }
            h2 {
                font-size: 100px;
            }
        }
    }
    @media(max-width: 1080px) {
        .hero-content {
            h1 {
                font-size: 72px;
            }
            h2 {
                font-size: 72px;
            }
            p {
                font-size: 32px;
            }
        }
    }
    @media(max-width: 767px) {
        .hero-content {
            h1 {
                font-size: 48px;
            }
            h2 {
                font-size: 48px;
            }
            p {
                font-size: 24px;
            }
        }
    }
    @media(max-width: 415px) {
        .hero-content {
            h1 {
                font-size: 28px;
            }
            h2 {
                font-size: 28px;
            }
            p {
                font-size: 18px;
            }
        }
    }
`

export default HeroSectionFade